import React, { Component } from 'react';
import { Modal, Spin, message, DatePicker, Select } from 'antd';
import Text from '../../../basicElement/Text';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import moment from 'moment';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';

class AssignEmployee extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    queryVitae = () => {
        const { record: { userId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeListByUserId,
            data: {
                userId,
                typeName: 'CHINESE',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data || [],
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = (params) => {
        this.setState({
            visible: true,
            record: {...params},
        }, () => {
            this.queryVitae();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    confirm = () => {
        const { record, record: { entryDate, vitaeId } } = this.state;
        if (!entryDate) {
            return message.warning('请选择人员到位时间！');
        }
        if (!vitaeId) {
            return message.warning('请选择人员简历！');
        }
        this.setState({
            visible: false,
        }, () => {
            this.props.process(record);
        })
    }

    handleChange = (value, key) => {
        const { data, record } = this.state;
        switch (key) {
            case 'vitaeId':
                const { vitaeId, vitaeName } = (data || []).find(i => i.vitaeId == value) || {};
                record.vitaeId = vitaeId;
                record.vitaeName = vitaeName;
            default:
                record[key] = value;
                break;
        }
        this.setState({ record });
    }

    render() {
        const { visible, loading, record: { employeeName, employeeCode, entryDate, vitaeId, userName }, data } = this.state;
        const vitaeOption = (data || []).map(i => <Option key={i.vitaeId}>{i.vitaeName}（{i.approvalStatusShow !==null?i.approvalStatusShow:'-'}）{i.createTime ? `(${String(i.createTime).slice(0, 10)})` : ''}</Option>);
        return (
            <Modal
                title="分派人员"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                width="480px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list fortyPercentage" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">分派人员:</div>
                                <div className="item-right">{userName}({employeeCode})</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left"><Text asterisk={true} colon={true}>人员到位时间</Text></div>
                                <div className="item-right">
                                    <DatePicker
                                        format={dateFormat}
                                        placeholder="请选择"
                                        style={{ width: 160 }}
                                        value={entryDate ? moment(entryDate) : null }
                                        onChange={(date, dateString) => this.handleChange(dateString, 'entryDate')}
                                    />
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left"><Text asterisk={true} colon={true}>人员简历</Text></div>
                                <div className="item-right">
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 240 }}
                                        value={vitaeId}
                                        onChange={value => this.handleChange(value, 'vitaeId')}
                                    >
                                        { vitaeOption }
                                    </Select>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default AssignEmployee;



// WEBPACK FOOTER //
// ./src/components/user/require/components/AssignEmployee.js